<template>
  <b-button
    ref="btn__previous-page"
    :variant="variant"
    class="btn__previous-page"
    :disabled="disabled"
    @click="$_handleClick"
  >
    <font-awesome-icon v-if="showArrow" icon="arrow-left" class="mr-u2" />

    <span> Back to previous page </span>
  </b-button>
</template>

<script>
import { pageNavigationMixin } from '@/mixins/pageNavigationMixin';

export default {
  mixins: [pageNavigationMixin],

  props: {
    previousPath: {
      type: String,
      default: null
    },

    variant: {
      type: String,
      default: 'outline-primary'
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    showArrow: {
      type: [Number, Boolean],
      default: false
    }
  },

  methods: {
    $_handleClick() {
      if (this.previousPath) {
        window.location.href = this.previousPath;
      } else {
        this.$_pageNavigationMixin_gotoPreviousPage();
      }
    }
  }
};
</script>
